import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5pnnp7uhbd: FaireBrandEntity = {
  token: "b_5pnnp7uhbd",
  type: "brand",
  name: "Lila Rice",
  avatarUrl:
    "https://cdn.faire.com/fastly/9d8ea980b9c566c90fe9e43499d81a69b102bbc7e228f87ab94daca8ad7ab7c8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7cbb6d6cc7f7a9252d8b2b0eb6191bb25ebf0e628000cdcec68ab95917997136.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9d8ea980b9c566c90fe9e43499d81a69b102bbc7e228f87ab94daca8ad7ab7c8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7cbb6d6cc7f7a9252d8b2b0eb6191bb25ebf0e628000cdcec68ab95917997136.jpeg",
  location: "Kingston, NY, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description: "Heirloom jewelry, handmade in upstate NY",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:00.735Z",
    importedBy: "entity-db-cli",
  },
};
